import { ReactNode } from "react";
import { useTlfEffects } from "./tlf/useTlfEffects";

export interface TlfVersion {
  id: string;
  azsolId: string;
  version: number;
}

export type TlfContextModalWindow =
  "LoadJson" | "Load" | "Replacements" | "RemoveStyles" | "SaveAs" | "";

export interface TlfContextProviderProps {
  children: ReactNode;
  readOnly?: boolean;
}

/**
 * Runs route-scoped TLF effects and renders its children.
 * TLF state and commands are provided by {@link useTlfContext} through AppSettings.
 *
 * @param params - Route read-only state and child content.
 * @param params.children - Child components rendered inside the TLF route.
 * @param params.readOnly - Whether this route must prevent TLF modifications.
 * @returns The child content unchanged.
 */
export const TlfContextProvider = ({
  children,
  readOnly = false,
}: TlfContextProviderProps): ReactNode => {
  useTlfEffects(readOnly);
  return <>{children}</>;
};

TlfContextProvider.displayName = "TlfContextProvider";
